<template>
    <div class="menu-parametres" :class="{ 'mobile': estMobile }">
        <h1>Parametres</h1>
        <ul class="niveau racine">
            <MenuNoeud v-for="(n, i) in arbre" :key="i" :noeud="n" @ouvrir="ouvrir" @action="faireAction" />
        </ul>
    </div>
</template>

<script>
    import { defineComponent } from 'vue';
    import menuParametres from '../script/menuParametres.js';
    import RequestManager from '../script/request.js';
    import MenuNoeud from './MenuNoeud.vue';

    export default defineComponent({
        components: { MenuNoeud },
        data() {
            return { arbre: menuParametres };
        },
        computed: {
            estMobile() { return RequestManager.estMobile; },
        },
        methods: {
            ouvrir(typpar) {
                this.$router.push({ name: 'ParametrageTable', query: { typpar } });
            },
            faireAction(noeud) {
                // Stubs des feuilles non-table (imports, MAJ base ref, options...) pour cette iteration.
                alert("Fonction non encore portee : " + noeud.label + " (" + noeud.action + ")");
            },
        },
    });
</script>

<style scoped>
    .menu-parametres { margin: 10px; max-width: 640px; }
    h1 { color: #01358D; font-size: 20px; }
    /* display:block explicite : neutralise la regle globale "ul { display:none }"  */
    /* qui fuit d'un autre composant (FicheDescriptive.vue, non scoped).            */
    ul.niveau { display: block; list-style: none; padding-left: 16px; margin: 0; }
    ul.niveau.racine { padding-left: 0; }
</style>
